import WeightDisplay from './WeightDisplay';

export default WeightDisplay;


// WEBPACK FOOTER //
// ./src/components/Others/WeightDisplay/index.tsx